import { inject } from '@vue/composition-api';
import VueRouter from 'vue-router';
import moduleConfig from '@/config/ModuleConfig';
import { readSSOInfo, checkInIframe } from '@/libs/util';
import useStore from './useStore';
import config from '@/config';

interface JumpPageParams {
    name: string;
    query?: Record<string, any>;
    params?: Record<string, any>;
    isOpen?: boolean;
    isReplace?: boolean;
}

export default () => {
    const router = inject('router') as VueRouter;
    const route = router.currentRoute;
    const { userModule } = useStore();
    const { isNewUi } = userModule.useState(['isNewUi']);

    /**
     * 根据模块 key 跳转页面
     * @param moduleKey
     * @param query
     * @param params
     */
    const jumpPageByModuleKey = (moduleKey: string, query = {}, params = {}) => {
        // eslint-disable-next-line no-prototype-builtins
        if (moduleConfig.hasOwnProperty(moduleKey)) {
            // @ts-ignore
            const moduleName = moduleConfig[moduleKey];
            console.log('moduleName', moduleName);
            router.replace({
                name: moduleName,
                query,
                params,
            }).catch(() => {});
        } else {
            router.replace('chat').catch(() => {});
        }
    };

    /**
     * 跳转页面
     * 判断是否在 iframe 中，如果在 iframe 中，且 ssoInfo.page_model 为 1，则直接跳转
     * @param params
     */
    const jumpPage = (params: JumpPageParams) => {
        const _name = params.name;
        const _params = params.params || {};
        const _query = params.query || {};
        const _isOpen = params.isOpen || false;
        const _isReplace = params.isReplace || false;
        const _ssoInfo = readSSOInfo();
        const _isIframe = checkInIframe() && _ssoInfo.page_model === '1';

        let { href } = router.resolve({
            name: _name,
            params: _params,
            query: _query,
        });

        let redirectToNew = false;

        // 跳转新版界面
        if (!['0', '1'].includes(isNewUi.value) && !config.siteConfig.brand) {
            href = `/next${href}`;
            redirectToNew = true;
        }

        if (_isOpen) {
            if (_isIframe) {
                if (redirectToNew) {
                    window.location.href = href;
                } else {
                    router.push({
                        name: _name,
                        params: _params,
                        query: _query,
                    }).catch(() => {
                    });
                }
            } else {
                window.open(href, '_blank');
            }
        } else if (_isReplace) {
            if (redirectToNew) {
                window.location.replace(href);
            } else {
                router.replace({
                    name: _name,
                    params: _params,
                    query: _query,
                }).catch(() => {});
            }
        } else if (redirectToNew) {
            window.location.href = href;
        } else {
            router.push({
                name: _name,
                params: _params,
                query: _query,
            }).catch(() => {
            });
        }
    };

    return {
        route,
        router,
        jumpPageByModuleKey,
        jumpPage,
    };
};
